import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, of, ReplaySubject, Subject } from "rxjs";
import { PaginationResponse } from "src/app/classes";
import { DoubletSuggestion } from "../../shared/classes";
import { IDoubletProviderService, IOfferProviderService } from "../../shared/interfaces";
import { Offer } from "../classes";
import { OfferService } from "./offer.service";

@Injectable()
export class CreateOfferService implements IDoubletProviderService, IOfferProviderService {

    offer$ = of(null);
    offerId$ = of(null);

    private _checkerVisible = new BehaviorSubject<boolean>(true);
    checkerVisible$ = this._checkerVisible.asObservable();

    private _doubletClicked = new Subject<DoubletSuggestion>();
    doubletClicked$ = this._doubletClicked.asObservable();

    private _doublets = new ReplaySubject<PaginationResponse<DoubletSuggestion[]>>(1);
    doublets$ = this._doublets.asObservable();

    constructor(
        private _offerService: OfferService,
        private _router: Router
    ) { }

    doubletClick = (doublet: DoubletSuggestion) => {
        this._doubletClicked.next(doublet);
        this._router.navigate(['/offer-details', doublet.identifier]);
    }

    setSearchFilter(){
        throw new Error("not implemented");
    }

    setSearchString = (term: string) => this._offerService.searchOffersByString(term, { 'pageNumber': 1, 'pageSize': 50 }).subscribe((x => {
        var result = {
            totalItems: x.totalItems,
            content: x.content.map((y: Offer) => {
                return {
                    title: [y.offernumber, y.offertitle].filter(z => z ? true : false).join(' '),
                    subTitles: [],
                    identifier: y.offerid
                } as DoubletSuggestion
            })
        } as PaginationResponse<DoubletSuggestion[]>;
        this._doublets.next(result);
    }));

    setDoubletCheckerVisible = (value: boolean) => this._checkerVisible.next(value);
}